import React, { useState } from 'react';
import CheckTicketModal from './CheckTicketModal';
import BarcodeScanner from './BarcodeScanner';
import QRCodeScanner from './QRCodeScanner';
import { CheckTicketContext } from './CheckTicketContext';

export default function ScannerModalContent() {
    const [checkTicketContext, setCheckTicketContext] = useState({
        scannerStarted: false,
        ticketId: null,
        checkbetUrl: null,
        update(updt) {
            setCheckTicketContext(prev => {
                return {...prev, ...updt};
            });
        },
        reset() {
            this.update({ticketId: null, checkbetUrl: null, scannerStarted: false});
        },
        setScannerStarted(scannerStarted, scannerType) {
            this.update({scannerStarted, scannerType});
        },
        setTicketId(ticketId) {
            if (ticketId) {
                this.update({ticketId: ticketId, checkbetUrl: null, scannerStarted: false});
            }
        },
        setCheckbetUrl(checkbetUrl) {
            if (checkbetUrl) {
                this.update({checkbetUrl: checkbetUrl, ticketId: null, scannerStarted: false});
            }
        }
    });

    return (
        <CheckTicketContext.Provider value={checkTicketContext}>
            {checkTicketContext.scannerStarted ?
                <>
                    {checkTicketContext.scannerType === 'BARCODE' ?
                        <BarcodeScanner />
                        :
                        <QRCodeScanner />
                    }
                </>
                :
                <CheckTicketModal />
            }
        </CheckTicketContext.Provider>
    );
}
